// ============================================================
// True News blog — interactions
//   1) Category tabs — filter the archive by category (Explore = all)
//   2) Trending carousel arrows + arrow dimming at the ends
//   3) Archive "Load More" — reveals index rows past the 9th
// ============================================================

// 1) Category filtering — a category tab hides Latest/Trending and shows every
//    matching archive row (including ones Load More hasn't revealed); Explore
//    restores the default layout without disturbing the Load More state.
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('#trueNews .categories ul li a');
  if (!tabs.length) return;

  const archive = document.querySelector('#trueNews .archive');
  const archiveList = document.querySelector('#trueNews .archive-list');
  const zones = document.querySelectorAll('#trueNews [data-tn-zone]');
  const rows = archiveList ? Array.from(archiveList.querySelectorAll('.tn-row')) : [];

  const categoryOf = (row) => {
    const cat = row.querySelector('.cat');
    return cat ? cat.textContent.trim().toLowerCase() : '';
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', function (e) {
      e.preventDefault();
      tabs.forEach((l) => l.classList.remove('active'));
      this.classList.add('active');

      const showAll = this.hasAttribute('data-show-all');
      const filter = showAll ? '' : this.textContent.trim().toLowerCase();

      zones.forEach((zone) => zone.classList.toggle('tn-zone-hidden', !showAll));
      if (archive) archive.classList.toggle('is-filtered', !showAll);
      if (archiveList) archiveList.classList.toggle('is-filtered', !showAll);

      const matches = [];
      rows.forEach((row) => {
        const match = !showAll && categoryOf(row) === filter;
        row.classList.toggle('tn-row--match', match);
        row.classList.remove('tn-row--match-last');
        if (match) matches.push(row);
      });
      if (matches.length) matches[matches.length - 1].classList.add('tn-row--match-last');
    });
  });
});

// 2) Trending carousel
const trendingSection = document.getElementById('trendingSection');
const scrollLeftBtn = document.getElementById('scrollLeft');
const scrollRightBtn = document.getElementById('scrollRight');

if (trendingSection && scrollLeftBtn && scrollRightBtn) {
  // one card + flex gap, measured so the step stays correct across breakpoints
  function scrollAmount() {
    const card = trendingSection.querySelector('.tn-card--trend');
    if (!card) return 322;
    return card.offsetWidth + (parseFloat(getComputedStyle(trendingSection).gap) || 22);
  }

  scrollLeftBtn.addEventListener('click', () => {
    trendingSection.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
  });
  scrollRightBtn.addEventListener('click', () => {
    trendingSection.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
  });

  function updateArrowVisibility() {
    const { scrollLeft, scrollWidth, clientWidth } = trendingSection;
    scrollLeftBtn.style.opacity = scrollLeft > 4 ? '1' : '0.35';
    scrollRightBtn.style.opacity = scrollLeft < scrollWidth - clientWidth - 4 ? '1' : '0.35';
  }
  trendingSection.addEventListener('scroll', updateArrowVisibility);
  window.addEventListener('resize', updateArrowVisibility);
  updateArrowVisibility();
}

// 3) Load More (archive index rows)
document.addEventListener('DOMContentLoaded', function () {
  const loadMoreBtn = document.getElementById('loadMoreBtn');
  const archiveList = document.querySelector('.archive-list');
  if (!loadMoreBtn || !archiveList) return;

  const hiddenRows = archiveList.querySelectorAll('.tn-row.hidden');
  let loaded = 0;
  const perLoad = 6;

  if (hiddenRows.length === 0) {
    loadMoreBtn.style.display = 'none';
    return;
  }

  loadMoreBtn.textContent = `Load More (${hiddenRows.length} remaining)`;

  loadMoreBtn.addEventListener('click', function () {
    const toShow = Math.min(perLoad, hiddenRows.length - loaded);
    for (let i = loaded; i < loaded + toShow; i++) {
      const row = hiddenRows[i];
      if (!row) continue;
      row.classList.remove('hidden');
      row.style.opacity = '0';
      row.style.transform = 'translateY(14px)';
      setTimeout(
        () => {
          row.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
          row.style.opacity = '1';
          row.style.transform = 'translateY(0)';
        },
        (i - loaded) * 80,
      );
    }
    loaded += toShow;

    const remaining = hiddenRows.length - loaded;
    if (remaining <= 0) {
      loadMoreBtn.textContent = 'All posts loaded';
      loadMoreBtn.disabled = true;
      setTimeout(() => loadMoreBtn.classList.add('hidden'), 1600);
    } else {
      loadMoreBtn.textContent = `Load More (${remaining} remaining)`;
    }
  });
});
